import React, { useEffect, useState, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import { Link, useLocation } from "react-router-dom";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,} from "recharts";

export default function Dashboard() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState([{ label: "Dashboard", url: "/Dashboard" },]);
  const location = useLocation();

  const fetchDetails = useCallback(async () => {
    try {
      const response = await fetch(`/api/getNewsTitle`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });
      if (response.ok) {
        const Data = await response.json();
        setData(Data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }, []);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);

  useEffect(() => {
    const routeParts = location.pathname.split("/").filter(Boolean);
    let url = "";
    const crumbs = [{ label: "Dashboard", url: "/Dashboard" }];
    routeParts.forEach((p) => {
      url += `/${p}`;
      crumbs.push({ label: p, url });
    });
    setBreadcrumbs(crumbs);
  }, [location]);

  const chartData = [
    { name: "Active", value: 5 },
    { name: "Closed", value: 2 },
    { name: "Pending", value: 1 },
    { name: "Paid", value: 2 },
  ];

  return (
    <>
      <div className="mx-4 mt-4">
        <nav>
          <ol className="flex text-sm text-gray-500 space-x-2">
            {breadcrumbs.map((b, i) => (
              <li key={i}>
                {i !== breadcrumbs.length - 1 ? (
                  <Link to={b.url} className="hover:text-blue-600">
                    {b.label} /
                  </Link>
                ) : (
                  <span className="text-gray-800">{b.label}</span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>

      <div className="p-4 sm:p-6 lg:p-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { title: "Loan", path: "/ManageLoans", color: "from-blue-500 to-cyan-500" },
            { title: "FDR", path: "/ManageFDR", color: "from-purple-500 to-indigo-500" },
            { title: "RD", path: "/ManageRD", color: "from-emerald-500 to-teal-500" },
          ].map((item) => (
            <Link key={item.title} to={item.path}>
              <div
                className={`p-6 rounded-2xl text-white bg-gradient-to-r ${item.color} shadow-lg hover:scale-105 transition`}
              >
                <h2 className="text-xl font-semibold">{item.title}</h2>
                <p className="text-sm opacity-80 mt-1">
                  Manage {item.title} Accounts
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mt-8">
          {[
            { label: "Active", value: 5 },
            { label: "Closed", value: 2 },
            { label: "Pending", value: 1 },
            { label: "Paid", value: 2 },
          ].map((stat) => (
            <div
              key={stat.label}
              className="bg-white p-5 rounded-xl shadow text-center"
            >
              <p className="text-sm text-gray-500">{stat.label}</p>
              <h3 className="text-2xl font-bold text-gray-800">
                {stat.value}
              </h3>
            </div>
          ))}
        </div>

        <div className="bg-white p-6 rounded-xl shadow mt-8">
          <h2 className="text-lg font-semibold mb-4">Loan Overview</h2>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}
